import { render, staticRenderFns } from "./IndexBillingPortal.vue?vue&type=template&id=39dc2212&"
import script from "./IndexBillingPortal.vue?vue&type=script&lang=js&"
export * from "./IndexBillingPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports